import { render } from "./NoticeAddFiles.vue?vue&type=template&id=50a9f390&scoped=true"
import script from "./NoticeAddFiles.vue?vue&type=script&lang=js"
export * from "./NoticeAddFiles.vue?vue&type=script&lang=js"

import "./NoticeAddFiles.vue?vue&type=style&index=0&id=50a9f390&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_sindico\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a9f390"]])

export default __exports__